import { axios } from 'services/axios'
import { routes } from 'services/routes'

import type { FetchUserResponse } from './types'

export const fetchUser = async () => {
  const response = await axios.get<FetchUserResponse & { user: { availableLanguages: string[] } }>(routes.userPath())

  if (!response) {
    throw new Error('Couldn\'t fetch user info')
  }

  return response.data
}
